module.exports = __webpack_public_path__ + "static/media/footer_logo_small.4bf55b06.svg";